import {
  addDays, endOfDay, isSameDay, startOfDay,
} from 'date-fns';

interface DatepickerInterval {
  start: Date;
  end: Date;
}

export default function sortedDatesAsIntervals(sortedDates: Date[]): DatepickerInterval[] {
  const intervals: DatepickerInterval[] = [];
  const validDates = sortedDates.filter((date) => !Number.isNaN(date.getTime()));

  if (validDates.length === 0) return intervals;

  let currentStart = validDates[0];
  let currentEnd = currentStart;

  for (let i = 1; i < validDates.length; i += 1) {
    const date = validDates[i];
    const expectedNextDate = addDays(currentEnd, 1);
    const datesMatch = isSameDay(date, expectedNextDate);

    if (datesMatch) {
      currentEnd = date;
    } else {
      intervals.push({
        start: startOfDay(currentStart),
        end: endOfDay(currentEnd),
      });
      currentStart = date;
      currentEnd = date;
    }
  }

  intervals.push({
    start: startOfDay(currentStart),
    end: endOfDay(currentEnd),
  });

  return intervals;
}
